export default "__VITE_ASSET__wIfwTqXJ__"